import React from 'react';
import { Link } from 'react-router-dom';
import HeaderSlider from '../../pages/HeaderSlider';


const EventStaff = () => {
    return (
        <>
            {/* <!-- Breadcromb Area Start --> */}
            <section className="bleezy-breadcromb-area">
                {/* <div className="breadcromb-top event-staff">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-top-text">
                                    <h2 className="banner-heading">Event Staff</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                                    <HeaderSlider src="../../assets/img/Gallery/event.avif" title="Event Staff" />
                
                <div className="breadcromb-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-bottom-text">
                                    <ul>
                                        <li><Link to="/">home</Link></li>
                                        <li><a href="#"><i className="fa fa-long-arrow-right"></i></a></li>
                                        <li>Event Staff</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Breadcromb Area End --> */}

            <section class="bleezy-blog-page-area" style={{ paddingTop: '15px', paddingBottom: '15px' }}>
                <div class="container">
                    <div class="mid-title  mb-5 "><h2 class="heading-with-border"><strong>Event Staff</strong></h2>
                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                            Planning an event and need trained, professional event staff in India?
                        </p>
                        <p className='octo-para sub-heading-m-t-15 sub-heading-m-b-15'>
                            The success of any event depends upon only one single factor – people engaged in the event. Getting the best of staff for your event, is a sure way to get desired result out of an event. We provide quality and professional staff for various events in India. We have successful provided staff for many corporate events in India. We provide following category of staff for events:
                        </p>
                        <ul class="list">
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Event Anchor / Host</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Models / Eye Candy</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Information Desk Staff</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Guest Greeters</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Guest Registration Staff</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Pamphlet Distribution Staff</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Exhibition Attendants</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Tele-caller</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Mall Promoter</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Parking Assistant</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Bar Tender</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  DJ</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Magician</li>

                        </ul>
                        <p className='octo-para sub-heading-m-t-15 sub-heading-m-b-15'>
                            Make your event a success with our professional event staff service in India. From hospitality to coordination, our manpower ensures every detail is handled with care.
                        </p>
                        <h3 className="sub-heading-page sub-heading-m-t-15 sub-heading-m-b-15"><strong>Why Us:</strong></h3>

                        <ul class="list">
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Dual benefit of hiring all security needs and event staffing solution under one roof</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Skilled in guest handling and event coordination</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Event Staff available for hours, days or entire event duration</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Professional and experience staff</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Large pool of young staff</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Strict adherence to timeline</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Dedicated one point contact person throughout your event</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Cost effective and competitive pricing</li>

                        </ul>

                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                            This service is currently available in India and Pune only. Hire our event staff to make your event a grand success.
                        </p>

                        <h3 className="sub-heading-page sub-heading-m-t-15 sub-heading-m-b-15"><strong>Make Your Event a Success!</strong></h3>

                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                            With Octopuss Security’s event staffing solutions, you can focus on your event while we take care of hospitality, guest management, and behind-the-scenes support. Every staff member is carefully selected, trained, and monitored to ensure quality service.</p>
                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                            📞 Hire professional event staff in India today — contact us for customized packages to fit your event requirements
                        </p>

                    </div>
                </div>
            </section>

        </>
    )
}

export default EventStaff;
